module.exports = __webpack_public_path__ + "static/media/match-invoices.0dd8d9af.png";